import { businessErrorFactory, BusinessError } from '../../../../common/business-error';

const REJECT_AN_ORDER_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and your order could not be rejected. Please try again. If the problem still persists, please contact support.';

const OPERATION_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry, but we could not find your order. Please refresh page and try again. If the problem still persists, please contact support.';

const REJECTION_NOT_ALLOWED =
  // eslint-disable-next-line max-len
  'Sorry, but we could not reject your order because it has already been confirmed. If you need help with this order, please contact support.';

export enum BUSINESS_ERRORS {
  'OPERATION_NOT_FOUND' = 'OPERATION_NOT_FOUND',
  'REJECTION_NOT_ALLOWED' = 'REJECTION_NOT_ALLOWED'
}

export const getRejectAnOrderBusinessError = (businessError: BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.OPERATION_NOT_FOUND: {
      return businessErrorFactory({ message: OPERATION_NOT_FOUND, severity: 'error' });
    }
    case BUSINESS_ERRORS.REJECTION_NOT_ALLOWED: {
      return businessErrorFactory({ message: REJECTION_NOT_ALLOWED, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({
        message: REJECT_AN_ORDER_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
